import { ErrorBoundary } from 'react-error-boundary'
import { Link, Outlet } from 'react-router-dom'

import type { ReactElement } from 'react'

import enjoyLogoWhite from '@/assets/enjoy-logo-white.webp'
import { ErrorFallback } from '@/components/shared/error-fallback'
import { CookieConsent } from '@/features/ecosystem/components/cookie-consent'
import { EcosystemSearch } from '@/features/ecosystem/components/ecosystem-search'


export function PublicLayout(): ReactElement {
  return (
    <div className="flex min-h-screen flex-col bg-navy bg-[radial-gradient(120%_40%_at_50%_0%,#0B2230_0%,#00131F_55%)] font-body font-light text-[#D9D3C8] antialiased">
      <header className="sticky top-0 z-40 flex flex-wrap items-center gap-x-6 gap-y-3 border-b border-gold/[0.22] bg-[rgba(0,15,24,0.82)] px-5 py-4 backdrop-blur-[12px] sm:px-8">
        <Link
          to="/"
          aria-label="Ecossistema Enjoy"
          className="flex min-h-[44px] items-center"
        >
          <img
            src={enjoyLogoWhite}
            alt="Enjoy"
            className="h-8 w-auto max-w-full"
            width={120}
            height={32}
          />
        </Link>

        <nav className="ml-auto flex flex-1 flex-wrap items-center justify-end gap-x-6 gap-y-3">
          <Link
            to="/sobre"
            className="inline-flex min-h-[44px] items-center whitespace-nowrap text-[0.78rem] uppercase tracking-[0.1em] text-[#C4BEB2] transition-colors hover:text-gold-2"
          >
            Sobre o Ecossistema
          </Link>
          <EcosystemSearch />
        </nav>
      </header>

      <main className="flex-1">
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <Outlet />
        </ErrorBoundary>
      </main>

      <footer className="border-t border-gold/[0.22] px-6 py-6 text-center font-display text-[0.78rem] italic text-eco-muted">
        Enjoy &middot; Ecossistema de Negocios &mdash; cada conexao gera dado, cada dado gera oportunidade, cada oportunidade gera receita. &copy; {new Date().getFullYear()}
      </footer>

      <CookieConsent />
    </div>
  )
}
